module.exports = __webpack_public_path__ + "img/alean2016-min.0405e105.jpg";